import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

// FLEX-8878
// Load map/ldp related controllers separate from the other controllers.  And
// only when needed.
// These controllers are the ones that reference MarkerLabel.  This is a 
// third party file that has self-executing code that assumes google maps
// is present.
// By loading these separately, we can remove the dynamic loading of js files
// that cause IDX references to break.
const context = require.context("../src/controllers/map", false, /\.js$/);

window.Stimulus.load(definitionsFromContext(context))
